module.exports = __webpack_public_path__ + "static/media/refresh-icon.88c3d2bb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/refresh-icon.svg
// module id = 32
// module chunks = 1